<div class="home-wrapper">
    <div class="home-image"></div>
    <div class="container">
        <h1>Capturing <span class="script">"The Look"</span> that is uniquely yours</h1>
    </div>
</div>
